import {
  createBaseQuery,
  createServerSideRequestOption,
  getBaseUrl,
} from "@/redux/config";
import { createApi } from "@reduxjs/toolkit/query/react";

export const getCompanyServicesTxTypes = async ({
  companyId,
  serviceId,
  request,
}: {
  companyId: number;
  serviceId: number;
  request: Request;
}) => {
  return await createServerSideRequestOption({
    url: `${getBaseUrl()}/api/v1/c/${companyId}/services/${serviceId}/tx-types`,
    request: request,
    method: "GET",
  });
};

export const serviceTxTypeApi = createApi({
  reducerPath: "serviceTxTypeApi",
  baseQuery: createBaseQuery("/c/"),
  tagTypes: ["serviceTxType"],
  endpoints: (build) => ({
    bulkSave: build.mutation<
      ServiceTxType[],
      { companyId: number; serviceId: number; data: BulkServiceTxTypeData }
    >({
      query: ({ companyId, serviceId, data }) => ({
        url: `/${companyId}/services/${serviceId}/tx-types/bulk-create`,
        method: "POST",
        body: data,
      }),
    }),
    loadServiceTxTypes: build.query<
      ServiceTxType[],
      { companyId: number; serviceId: number }
    >({
      query: ({ companyId, serviceId }) => ({
        url: `/${companyId}/services/${serviceId}/tx-types`,
        method: "GET",
      }),
    }),
    createServiceTxType: build.mutation<
      ServiceTxType,
      { companyId: number; serviceId: number; data: ServiceTxTypeData }
    >({
      query: ({ companyId, serviceId, data }) => ({
        url: `/${companyId}/services/${serviceId}/tx-types`,
        method: "POST",
        body: data,
      }),
    }),
    editServiceTxType: build.mutation<
      ServiceTxType,
      { companyId: number; serviceId: number; data: ServiceTxTypeData }
    >({
      query: ({ companyId, serviceId, data }) => ({
        url: `/${companyId}/services/${serviceId}/tx-types`,
        method: "PUT",
        body: data,
      }),
    }),
  }),
});
